import { useState } from "react";
import styled from "styled-components";
import {
  SecondaryNavigationMenuItem,
  SecondaryNavigation,
  Text,
} from "melco-ui";
import { Dropdown } from "antd";
import { useCurrentUser, userInitials } from "melco-shared-logic";
import SecondaryNavigationMenu from "./SecondaryNavigationMenu";
import { HelpLink } from "./HelpLink";

const StyledName = styled.div`
  text-transform: uppercase;
  position: absolute;
  width: 40px;
  height: 40px;
  text-align: center;
  vertical-align: middle;
  line-height: 40px;
`;

const AccountSecondaryNavigation: React.FC = () => {
  const currentUser = useCurrentUser();
  const [isVisible, setVisible] = useState(false);

  return (
    <SecondaryNavigation>
      <HelpLink />
      {currentUser && (
        <SecondaryNavigationMenuItem
          prefix={
            currentUser.accountName && (
              <Text
                type="secondary"
                ellipsis={{ tooltip: currentUser.accountName }}
                data-cy-id="floating-navigation-user-account-name"
              >
                {currentUser.accountName}
              </Text>
            )
          }
        >
          <Dropdown
            overlay={
              <SecondaryNavigationMenu setDropDownVisible={setVisible} />
            }
            trigger={["click"]}
            arrow
            open={isVisible}
            onOpenChange={(v) => setVisible(v)}
          >
            <StyledName data-cy-id="floating-navigation-user-initials">
              {userInitials(currentUser)}
            </StyledName>
          </Dropdown>
        </SecondaryNavigationMenuItem>
      )}
    </SecondaryNavigation>
  );
};

export default AccountSecondaryNavigation;
